export const ALO_ACCESS = 'ALO_ACCESS'
export const PREMIUM = 'PREMIUM'
export const LIMITED = 'LIMITED'

export const ALO_ACCESS_MEMBERSHIP = 'ALO_ACCESS'
const PREMIUM_MEMBERSHIP = 'PREMIUM'

export const isAloAccessType = (type) => [ALO_ACCESS].includes(type)
export const hasAloAccessMembership = (tier) =>
  [ALO_ACCESS_MEMBERSHIP].includes(tier)

export const ALO_YOGA_HOME_URL =
  window?.REACT_ENV_VARIABLES?.ALO_YOGA_HOME_URL || 'https://aloyoga.com'

export const hasPremiumAccessMembership = (tier) => PREMIUM_MEMBERSHIP === tier

export const CANCEL_MEMBERSHIP_SURVEY_URL =
  window?.REACT_ENV_VARIABLES?.CANCEL_MEMBERSHIP_SURVEY_S3_URL ||
  'https://alomoves.s3.amazonaws.com/manual_uploads/shared/surveys/cancellation/cancellation_survey_questions_dev_v3.json'

export const TERMS_OF_SERVICE_URL = `${ALO_YOGA_HOME_URL}/pages/terms-of-use`
export const PRIVACY_POLICY_URL = `${ALO_YOGA_HOME_URL}/pages/privacy-policy`
export const COOKIE_POLICY_URL = `${ALO_YOGA_HOME_URL}/pages/cookie-policy`
